import { render } from "./SignUpFlowLayout.vue?vue&type=template&id=2e6d6a60&scoped=true"
import script from "./SignUpFlowLayout.vue?vue&type=script&lang=js"
export * from "./SignUpFlowLayout.vue?vue&type=script&lang=js"

import "./SignUpFlowLayout.vue?vue&type=style&index=0&id=2e6d6a60&lang=scss&scoped=true"
import "./SignUpFlowLayout.vue?vue&type=style&index=1&id=2e6d6a60&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6d6a60"]])

export default __exports__